import { Card } from 'antd';
import styled from 'styled-components';
import colors from 'theme/colors';

export const CardStyled = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  background: ${colors.white};
  box-shadow: 0 0.063rem 0.25rem rgba(0, 0, 0, 0.07);
  border-radius: 0.125rem;
  height: 7.375rem;
  margin-top: 1.25rem;
  .ant-card-body {
    display: flex;
    width: 100%;
  }
`;

export const DocumentTypeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const DocumentTypeItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 16.6%;

  span:nth-child(2) {
    margin-top: 0.625rem;
  }
`;

export const DocumentInfoStyled = styled.span`
  font-weight: bold;
  font-size: 1.25rem;
  line-height: 1.375rem;
  font-family: Sarabun;
  color: rgba(0, 0, 0, 0.65);
`;

export const FileUploadContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;
